import { atom } from 'recoil';
import { DvfDisplayRangeMm } from '~/domain/dvf/dvfDisplayRange';
import { DVF_SPACING_MM_DEFAULT } from '~/hooks/workflows/dvf/dvfSpacing';

export const deformationArrowsEnabledState = atom<boolean>({
    key: 'deformationArrowsEnabledState',
    default: false,
});

export const deformationGridEnabledState = atom<boolean>({
    key: 'deformationGridEnabledState',
    default: false,
});

export const deformationHeatmapEnabledState = atom<boolean>({
    key: 'deformationHeatmapEnabledState',
    default: false,
});

export const deformationArrowSpacingMmState = atom<number>({
    key: 'deformationArrowSpacingMmState',
    default: DVF_SPACING_MM_DEFAULT,
});

export const deformationGridSpacingMmState = atom<number>({
    key: 'deformationGridSpacingMmState',
    default: DVF_SPACING_MM_DEFAULT,
});

export const deformationDisplayRangeMmState = atom<DvfDisplayRangeMm | null>({
    key: 'deformationDisplayRangeMmState',
    default: null,
});

// SOP instance UIDs of the deformable registrations the spread is measured across.
export const deformationUncertaintySourcesState = atom<readonly string[]>({
    key: 'deformationUncertaintySourcesState',
    default: [],
});

export const deformationUncertaintyEnabledState = atom<boolean>({
    key: 'deformationUncertaintyEnabledState',
    default: false,
});
